import Crud from '../components/Workstations/Crud'
import Entity from '../components/Workstations/Add'
import View from '../components/Workstations/View'
import Configuration from '../components/Workstations/Configuration'

let routes = {
    path: '/workstations',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        {
            path: '/workstations/configuration/:id',
            name: 'Configuração',
            component: Configuration
        },
        {
            path: '/workstations/add',
            name: 'Nova Workstation',
            component: Entity
        },
        {
            path: '/workstations/edit/:id?',
            name: 'Editar Workstation',
            component: Entity
        },
        {
            path: '/workstations/view/:id?',
            name: 'Visualizar Workstation',
            component: View
        },
        {
            path: '/workstations',
            name: 'Workstations',
            component: Crud
        },
    ]
};


export default routes



// WEBPACK FOOTER //
// ./src/router/workstation.js